import {css} from '@isceco/widget-library2/external/lit'

export default css`
  :host {
    font-family: var(--isceco-font);
    display: block;
  }

  /* hide default arrow */

  details > summary {
    list-style: none;
  }

  details > summary::marker,
  details > summary::-webkit-details-marker {
    display: none;
  }

  details {
    width: 100%;
    border: 1px solid var(--isceco-color-grey-100);
    border-radius: var(--isceco-space-100);
  }

  summary {
    font-weight: bold;
    font-size: 1.25rem;
  }

  summary.preview-disabled > i {
    color: var(--isceco-color-grey-300);
    opacity: 0.4;
  }

  summary.preview-disabled > i.icon:hover {
    opacity: 0.4;
  }

  details > summary {
    padding: var(--isceco-space-200);
    cursor: pointer;
    background-color: var(--isceco-color-grey-100);
  }

  details > summary:hover {
    background-color: var(--isceco-color-blue-100);
  }

  details > summary > i {
    color: var(--isceco-color-blue-500);
    transition: all .5s ease-in-out;
  }

  details[open] > summary > i {
    transform: rotate(90deg);
  }

  details > .content {
    padding: var(--isceco-space-200);
    background-color: var(--isceco-color-white-500);
  }
`
